<template>
  <div>
    <el-tree
      ref="tree"
      :data="rbacTree"
      show-checkbox
      node-key="actionId"
      default-expand-all
      :expand-on-click-node="false"
      :check-on-click-node="true"
      class="content"
    >
      <span
        slot-scope="{ node, data }"
        @click="test(node)"
        :class="[
          {
            foo: node.level === 4
          },
          { first: node.level === 1 }
        ]"
      >
        <!-- ||
              (node.level === 3 && node.childNodes.length === 0) ||
              (node.level === 2 && node.childNodes.length === 0) -->
        {{ data.actionName }}
      </span>
    </el-tree>
    <div style="text-align:end;margin-top:10px">
      <el-button :loading="sumbitLoading" @click="sumbit" type="primary" size="small" style="width:90px">
        {{ $t('system::common::btn::save') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { getMenuAuthList, saveMenuAuthList } from '@/server/system'
import { deepClone } from '@/utils'
import { toTree } from './utils'
export default {
  props: {
    roleId: {
      default: '',
      type: [Number, String]
    }
  },
  data() {
    return {
      rbacTree: [],
      authorizeDataIds: [],
      loading: false,
      sumbitLoading: false
    }
  },
  mounted() {
    this.getTree()
    this.getAuthDetail()
  },
  methods: {
    test(node) {
      console.log(node)
    },
    search() {
      this.getAuthDetail()
    },
    getTree() {
      // const menu = listToTree(deepClone(this.$store.state.user.authorityList), 5)
      const menu = toTree(deepClone(this.$store.state.user.authorityList))
      if (menu && menu.length) {
        this.rbacTree = this.checkAdminFlag(menu[0].children)
      }
      this.$nextTick(() => {
        this.changeCss()
      })
    },
    // 判断权限是否可以授权
    checkAdminFlag(list) {
      return list
        .filter(item => item.adminFlag && item.isShow === 1 && !item.isCustomer)
        .map(item => {
          let obj = { ...item }
          if (item.children && item.children.length) {
            obj.children = this.checkAdminFlag(item.children)
          }
          return obj
        })
    },
    async getAuthDetail() {
      this.loading = true
      const { data } = await getMenuAuthList(this.roleId)
      this.loading = false
      if (data.code === this.$code) {
        this.authorizeDataIds = data.data || []
        let authorizeDataIds = [...this.authorizeDataIds]
        authorizeDataIds = authorizeDataIds.filter(id => {
          const auth = this.$deepClone(this.checkActionId(id))
          if (!auth) return false
          // if (auth.children && auth.children.length && auth.actionId === id) {
          // return auth.children.every(item => this.authorizeDataIds.includes(item.actionId))
          if (auth.children && auth.children.length) {
            return false
          } else {
            return true
          }
        })
        this.$refs.tree.setCheckedKeys(authorizeDataIds)
      }
    },
    checkActionId(id, list) {
      if (!list) {
        list = this.$deepClone(this.rbacTree)
      }
      for (let o of list) {
        if (o.actionId === id) return o
        if (o.children && o.children.length) {
          const o_ = this.$deepClone(this.checkActionId(id, o.children))
          if (o_) return o_
        }
      }
    },
    changeCss() {
      let levelName = document.getElementsByClassName('foo')
      for (let i = 0; i < levelName.length; i++) {
        levelName[i].parentNode.style.float = 'left'
      }
      let first = document.getElementsByClassName('first')
      for (let i = 0; i < first.length; i++) {
        first[i].parentNode.style.backgroundColor = '#eaeef4'
        first[i].parentNode.style.marginTop = '10px'
      }
    },
    async sumbit() {
      const actionIds = [...this.$refs.tree.getHalfCheckedKeys(), ...this.$refs.tree.getCheckedKeys()]
      if (!actionIds.length) return this.$message.warning($t('system::rbac::menu_select'))
      const shopManagement = this.$store.state.user.authorityList.find(item => item.actionCode === 'shop-management')
      const shopManagementId = (shopManagement && shopManagement.actionId) || 0
      this.sumbitLoading = true
      const data = await saveMenuAuthList({
        roleId: this.roleId,
        actionIds: [shopManagementId, ...actionIds]
      })
      if (data.data.code === this.$code) {
        this.$message.success(this.$t('system::tip::save_success'))
      }
      this.sumbitLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-tree-node__content {
  padding: 5px 0;
}
/deep/.el-tree-node__content:hover {
  background-color: inherit;
}
/deep/.el-tree-node:focus > .el-tree-node__content {
  background-color: inherit;
}
.content {
  overflow: auto;
  height: 498px;
  margin-top: 16px;
}
</style>
